import { useContext, useState } from 'react';
import { Menu, X, LayoutDashboard, Users, Settings, LogOut, ChevronRight, Building2, Activity, TrendingUp } from 'lucide-react';
import SidebarSuperAdmin from './SidebarSuperAdmin';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';

export default function DashboardSuperAdmin() {
    const { logoutUser,  hasAnyRole,isAuthenticated,user } = useContext(AuthContext);
    const { showError, showSuccess } = useToast(); // Use the toast hook
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    // No automatic navigation needed here - routing is handled by React Router
    // The RoleBasedRoute component already handles authentication and superuser checks

    const getPageTitle = () => {
        const path = location.pathname;


        if (path === '/admin-panel') return 'Vue d’ensemble du système';
        if (path.startsWith('/admin-panel/organizations')) {
            if (path.includes('/add')) return 'Ajouter une organisation';
            return 'Organisations';
        }
    }

  return (
    <div className="flex h-screen bg-white">
      {/* Barre latérale */}
      <SidebarSuperAdmin sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Contenu principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* En-tête */}
        <header className="bg-white border-b border-gray-100 px-6 py-3 flex items-center justify-between">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden inline-flex items-center justify-center p-1.5 rounded hover:bg-gray-100 transition-colors"
          >
            {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
          
          <div className="flex-1 hidden lg:block">
            <h2 className="text-sm font-semibold text-gray-900">{getPageTitle()}</h2>
          </div>
          
          <div className="flex items-center space-x-3 text-xs">
            <div className="h-7 w-7 bg-gradient-to-r from-black to-gray-900 rounded-full flex items-center justify-center text-white font-semibold">
              <span className="h-4 w-4 text-green-500">CA</span>
            </div>
            <span className="text-gray-600 hidden sm:inline">Administrateur système</span>
          </div>
        </header>

        {/* Contenu défilant */}
        <main className="flex-1 overflow-auto bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
